import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, IconButton, Tooltip } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import CheckOut from './CheckOut';
import CheckOutCustomer from './CheckOutCustomer';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import ThemeToggle from './ThemeToggle';
// assets
import { IconMenu2 } from '@tabler/icons';
import { useState } from 'react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //
const elem = document.documentElement;
const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
    const [fullScreen, setFullScreen] = useState(false);
    const openFullScreen = () => {
        setFullScreen(true);
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
            /* Chrome, Safari & Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            /* IE/Edge */
            elem.msRequestFullscreen();
        }
    };

    const closeFullScreen = () => {
        setFullScreen(false);
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    };

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* header search */}
            <SearchSection />
            {/* <SearchSection /> */}
            {fullScreen ? (
                <Tooltip title="Exit Full Screen" placement="bottom">
                    <IconButton sx={{ marginLeft: 5 }} onClick={closeFullScreen} size="large">
                        <FullscreenIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <Tooltip title="Full Screen" placement="bottom">
                    <IconButton sx={{ marginLeft: 5 }} onClick={openFullScreen} size="large">
                        <FullscreenIcon />
                    </IconButton>
                </Tooltip>
            )}

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            {/* <NotificationSection /> */}
            <ThemeToggle />
            <CheckOut />
            <CheckOutCustomer />
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
